var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"word__list"},_vm._l((_vm.keywords),function(item,index){return _c('li',{key:index,staticClass:"word__item m10 pnt",on:{"click":function($event){return _vm.goPage(item.value)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }